import {Race} from './Race';
import {SportType} from './SportType';

export class RacePageParrent {

  race: Race = undefined;

  protected createRace(object) {
    this.race = new Race();
    this.race.id = object.id;
    const item = object.data();
    this.race.name = item.name;
    this.race.dateStart = item.dateStart;
    this.race.dateFinish = item.dateFinish;
    this.race.track = item.track;
    this.race.defaultCat = item.defaultCat;
    this.race.categories = item.categories;
    this.race.web = item.web;
    this.race.location = item.location;
    this.race.sameDate = item.sameDate;
    this.race.sportType = item.sportType;
    this.race.organizer = item.organizer;
    this.race.emailOr = item.emailOr;
    this.race.mobileOr = item.mobileOr;
    this.race.detail = item.detail;
    this.race.startFee = item.startFee;
    this.race.fioConfig = item.fioConfig;
    this.race.sportType.get().then( type => {
      const sportType = new SportType();
      sportType.id = type.id;
      sportType.type = type.data().type;
      sportType.category = type.data().category;
      this.race.sportType = sportType;
    });
  }

}
